import type { ValvePlacementInput } from "./ValvePlacementInput";
import { register } from "./ValvePlacementInput";

let valveCheckbox: HTMLInputElement;
let valvePlacementInput: ValvePlacementInput;
let valvePlacementInputInner: HTMLInputElement;
export function initializeCustomValvePlacement(): void {
	valveCheckbox = document.getElementById(
		"One-way%20degassing%20valve",
	) as HTMLInputElement;
	if (!valveCheckbox) {
		return;
	}
	valveCheckbox?.addEventListener("input", () => {
		handleChange();
	});
	initializeAdditionalFields();
}

function handleChange() {
	valvePlacementInputInner.required = valveCheckbox.checked;
	valvePlacementInput.style.display = valveCheckbox.checked ? "block" : "none";
}

/**
 * Initializes the valve placement field.
 *
 * @throws Error if the input is missing from the page.
 */
function initializeAdditionalFields() {
	register();
	valvePlacementInput = document.createElement("div", {
		is: "valve-placement-input",
	});
	const valveInputWrapper = valveCheckbox.parentNode;
	if (!valveInputWrapper?.parentNode) {
		throw new Error("Could not find valve input wrapper");
	}
	valveInputWrapper.parentNode.insertBefore(
		valvePlacementInput,
		valveInputWrapper.nextSibling,
	);
	const input = valvePlacementInput.querySelector("input");
	if (!input) {
		throw new Error("Could not find input for valve placement");
	}
	valvePlacementInputInner = input;
}
